// Used as fallback for salesUser role (contactPersonUserId filter not supported by searchTokens)
export const companiesByTypeByCompanyNumber = /* GraphQL */ `
  query CompaniesByTypeByCompanyNumber(
    $type: String!
    $number: ModelStringKeyConditionInput
    $filter: ModelCompaniesFilterInput
  ) {
    companiesByTypeByCompanyNumber(type: $type, number: $number, filter: $filter) {
      items {
        id
        number
        name
        nameSearch
        countryCode
        preferredCurrency
        closestPortUNCode
        contactPersonUserId
        type
        companyContactPersons {
          items { firstName lastName id }
        }
        addresses {
          additionalInformation building city company countryCode
          firstName lastName primary primaryBilling primaryShipping
          room province state street zip
        }
      }
    }
  }
`;

export const companiesByTypeByCompanyNameSearch = /* GraphQL */ `
  query CompaniesByTypeByCompanyNameSearch(
    $type: String!
    $nameSearch: ModelStringKeyConditionInput
    $filter: ModelCompaniesFilterInput
  ) {
    companiesByTypeByCompanyNameSearch(type: $type, nameSearch: $nameSearch, filter: $filter) {
      items {
        id
        number
        name
        nameSearch
        countryCode
        preferredCurrency
        closestPortUNCode
        contactPersonUserId
        type
        companyContactPersons {
          items { firstName lastName id }
        }
        addresses {
          additionalInformation building city company countryCode
          firstName lastName primary primaryBilling primaryShipping
          room province state street zip
        }
      }
    }
  }
`;

export const getCompanyById = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompanies(id: $id) {
      id
      number
      name
      nameSearch
      countryCode
      preferredCurrency
      closestPortUNCode
      contactPersonUserId
      type
      companyContactPersons {
        items {
          firstName
          lastName
          id
        }
      }
      addresses {
        additionalInformation
        building
        city
        company
        countryCode
        firstName
        lastName
        primary
        primaryBilling
        primaryShipping
        room
        province
        state
        street
        zip
      }
    }
  }
`;
